<template>
  <div>
    <div class="loading" v-if="loading" style="margin: 50% 0">
      <van-loading type="circular" color="#999" />
    </div>
    <div v-if="!loading">
      <section>
        <div class="header">
          <van-nav-bar
            :title="newData.title"
            left-text=" "
            left-arrow
            @click-left="onClickLeft"
          />
          <video
            :src="newData.video"
            controls="controls"
            :poster="newData.mobile_live_img"
            style="width: 100%; margin-top: 10px; object-fit: cover;"
            
          ></video>
          <div class="zbtitle">{{ newData.title }}</div>
          <div class="desc">
            {{ newData.summary }}
          </div>
        </div>
      </section>

      <section class="cd-container" style="background: #eee">
        <div class="live-item" v-for="(v, k) in newData.content" :key="k">
          <div class="my-video" style="margin: 0 15px 15px;">
            <video
              v-if="v.video !== ''"
              :src="v.video"
              :poster="v.video_img"
              controls="controls"
              style="width: 100%; margin-top: 10px; object-fit: cover;"
            ></video>
          </div>
          <div class="time">{{ v.publishTime }}</div>
          <div class="message" v-html="v.content"></div>
        </div>
      </section>
    </div>

    <footer1></footer1>
  </div>
</template>

<script>
import footer1 from "@/components/footer";
import { getView } from "../commJs/api";
import { wechatShare } from "../commJs/wechat";

export default {
  data() {
    return {
      loading: true,
    };
  },
  components: {
    footer1,
  },
  methods: {
    getView(id) {
      getView({ newsId: id }).then((res) => {
        if (res.code == 200) {
          this.newData = res.data.news;
          this.loading = false;
          document.title = res.data.news.title;

          wechatShare((document.title = res.data.news.title));
        } else {
          this.errorT = res.msg;
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.id = this.$route.params.id || 0;
    if (!this.id || this.id == 0) {
      this.error = "该文章不存在";
    } else {
      this.getView(this.id);
    }
  },
};
</script>

<style scoped lang="less">
  img {
      width: 100% !important;
      height: auto !important ;
  }
.header {
  background: #fff;
}
.contents {
  min-height: 60vh;
}
.zbtitle {
  padding: 20px;
  color: #000;
  background: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-top: 0;
}
.desc {
  padding: 20px;
  padding-top: 0;
  color: #999;
  background: #fff;
  font-size: 14px;
}
.photocentent {
  padding: 10px;
}

video {
  width: 100%;
  line-height: 0;
}

.title {
  padding: 10px;
  font-size: 18px;
  color: #3a60e1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  position: relative;
  padding-left: 20px;
  background: #eee;

  &:after {
    content: "";
    position: absolute;
    height: 15px;
    width: 2px;
    background: #3a60e1;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.cd-container {
  // padding: 20px;
  font-size: 14px;

  .live-item {
    //background: #fff;
    margin-bottom: 20px;
    // padding: 20px;
    padding: 5px;
    border-radius: 5px;
    border-bottom: 1px solid #ddd;
    .time {
      color: #999;
      margin-bottom: 15px;
      padding-left: 35px;
      position: relative;
      &:after {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 15px;
        width: 8px;
        height: 8px;
        background: #07c160;
        border-radius: 8px;
        content: "";
      }
    }
    .message {
      line-height: 30px;
      color: #333;
      font-size: 16px;
      padding: 0px;
      
    }
  }
}
</style>